import classNames from "classnames";
import React, { Component, Props, useState } from "react";
import ReactGlobe from "react-globe";
import * as THREE from "three";
import bgTexture from "../../assets/images/bg_4k.svg";
import globeMarkerSelected from "../../assets/images/globe-marker-selected.png";
import globeMarker from "../../assets/images/globe-marker.png";
import globeTexture from "../../assets/images/globe.jpg";
import { MainStore } from "../../stores/MainStore";
import classes from "./styles.module.scss";

//const ReactGlobe = require("react-globe");

interface IProps extends Props<Component> {
  store: MainStore;
}
function Globe(props: IProps) {
  let [focus] = useState(undefined);
  const [details] = useState(null);

  const { store } = props;
  const { selectedState } = store;

  const markers = store.getMarkers();
  if (!markers || !store) return null;
  let marker: any;
  if (selectedState && markers) {
    marker = markers.filter(
      m => m.city.toLowerCase() === selectedState.name.toLowerCase()
    )[0];
    if (marker) {
      focus = marker.coordinates;
    }
  } else if (details && !selectedState) {
    focus = undefined;
  }

  function onClickMarker(marker: any, store: any) {
    if (!store) return;
    store.selectState(store.getSelectedStateByName(marker.city));
  }

  function onDefocus(previousCoordinates: any, event: any) {
    store.selectState();
  }

  function getTooltipContent(marker: any) {
    return `${marker.city}`;
  }

  const GlobeReact = ReactGlobe as any;
  const globeClasses = classNames(
    classes.Globe,
    !props.store.loading ? classes.OnReady : ""
  );

  return (
    <div className={globeClasses}>
      <GlobeReact
        markers={markers}
        focus={focus}
        onClickMarker={(e: any) => onClickMarker(e, props.store)}
        onDefocus={onDefocus}
        globeOptions={{
          enableClouds: false,
          enableGlow: false,
          backgroundTexture: bgTexture,
          texture: globeTexture
        }}
        cameraOptions={{
          distanceRadiusScale: store.screen.isMobile ? 6 : 3,
          maxDistanceRadiusScale: 12,
          autoRotateSpeed: 0.8
        }}
        focusOptions={{
          animationDuration: 1500,
          distanceRadiusScale: 2
        }}
        markerOptions={{
          getTooltipContent,
          renderer: (marker: any) => {
            const textureImage =
              store.selectedState && marker.city === store.selectedState.name
                ? globeMarkerSelected
                : globeMarker;
            const texture = new THREE.TextureLoader().load(textureImage);
            const material = new THREE.MeshBasicMaterial({
              map: texture,
              transparent: true
            });
            const geometry = new THREE.PlaneGeometry(10, 10, 5, 5);
            geometry.lookAt(new THREE.Vector3(0, 0, -6));
            return new THREE.Mesh(geometry, material);
          }
        }}
      />
    </div>
  );
}

export default Globe;
